import { render, staticRenderFns } from "./TemplateDocs.vue?vue&type=template&id=7448aec5"
import script from "./TemplateDocs.vue?vue&type=script&lang=js"
export * from "./TemplateDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports